import type { TenantProfile } from '@hetivo/hetivo-lib-types';
import type { UseQueryOptions } from '@tanstack/react-query';

import type { TenantProfileApi } from './tenant-profile.api';
import { tenantProfileKeys } from './tenant-profile.keys';

/** The single source of truth for the `GET /tenants/me` query — cached 30 min, shared by every reader. */
const TENANT_PROFILE_STALE_TIME_MS = 30 * 60_000;

/**
 * The one place the tenant-profile query is declared (key + fetcher + `staleTime`). Both
 * `useTenantProfile` and `useTenantModules` read `GET /tenants/me`; sharing these options keeps them on a
 * single query key so the two hooks share one cache entry — and one network call (SWOOP-300). The client
 * comes from `useApiClient`, so the api is passed in rather than created here.
 */
export function tenantProfileQueryOptions(
  api: TenantProfileApi,
): Pick<UseQueryOptions<TenantProfile>, 'queryFn' | 'queryKey' | 'staleTime'> {
  return {
    queryFn: () => api.getTenantProfile(),
    queryKey: tenantProfileKeys.me(),
    staleTime: TENANT_PROFILE_STALE_TIME_MS,
  };
}
